import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { DropdownService } from 'projects/services/src/app/API/dropdown.service';
import { ShareDataService } from '../../share-data.service';

@Component({
	selector: 'app-trainer-education',
	templateUrl: './education.component.html',
	styleUrls: ['./education.component.css']
})
export class TrainerEducationComponent implements OnInit {
	public educationOptions = [];
	// personDetails: any;
	public yearsOptions = [];
	public monthsOptions = []; DropdownService;
	public totalYears = 0;
	public totalMonths = 0;
	localFileName: any = {};
	loggedInUser: any;
	currentUserInfo: any;
	constructor(
		private fb: FormBuilder,
		private dropdownService: DropdownService,
		private shareDataSerice: ShareDataService,
		private currentUserService: CurrentUserService,
	) { }
	@Input() group: FormGroup;
	@Input() firstTimeLoad: boolean;
	@Output() firstTimeLoadChange = new EventEmitter();
	ngOnInit() {
		// console.log(this.shareDataSerice.getData(), 'get education data');
		// this.shareDataSerice.getData();

		// this.getPersonalDetails();
		this.loggedInUser = this.currentUserService.decodeToken();
		this._getCurrentUser();
		this.getEducationOptions();
		this.setYearsOptions();
		this.setMonthsOptions();
		// if (this.firstTimeLoad && (this.currentUserInfo == undefined || this.currentUserInfo.educationalDetails.length == 0)) {
		// 	this.createEducationForm();
		// }

		this.firstTimeLoad = false;
		this.firstTimeLoadChange.emit(this.firstTimeLoad);

	}
	_getCurrentUser() {
		this.currentUserService.getAdditionalInfomartion().subscribe(loggedInUser => {
			this.currentUserInfo = loggedInUser;
			// if ((this.currentUserInfo.educationalDetails.length === 0 || this.currentUserInfo.educationalDetails == undefined)&& this.firstTimeLoad) {

			if (this.educationArray.value.length==0 && (this.currentUserInfo.educationalDetails.length === 0 || this.currentUserInfo.educationalDetails == undefined)) {
				this.createEducationForm();
			}
			this.educationArray.setValue([])
			// if (this.educationArray.value.length == 0 && this.firstTimeLoad) {
			if (this.currentUserInfo.educationalDetails && this.currentUserInfo.educationalDetails.length>0) {
				for(let k =0;k<this.educationArray.value.length;k++) {
					console.log(this.educationArray.value[k],"this.educationArray.value[k]")
					this.educationArray.value[k]= null
				}
	console.log("Inside >0",this.educationArray)
				for (let i = 0; i < this.currentUserInfo.educationalDetails.length; i++) {
					this.createEducationForm(this.currentUserInfo.educationalDetails[i]);
				}
				for (let i = 0; i < this.currentUserInfo.educationalDetails.length; i++) {
					if (this.currentUserInfo.educationalDetails[i].education == 'Uneducated') {
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('specialization').setValidators([]);
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('passingYear').setValidators([]);
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('document').setValidators([]);
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('specialization').updateValueAndValidity();
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('passingYear').updateValueAndValidity();
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('document').updateValueAndValidity();
					} else {
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('specialization').setValidators([Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z0-9 .\'-]+$')]);
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('passingYear').setValidators([Validators.required, Validators.maxLength(4), Validators.pattern('[1-9][0-9]{3}')]);
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('document').setValidators([Validators.required, ValidationService.fileValidator, ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'), ValidationService.fileSizeValidator(5)]);
						//  this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('specialization').updateValueAndValidity();
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('passingYear').updateValueAndValidity();
						this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][i].get('document').updateValueAndValidity();

					}
				}
			}



		});
	}
	get educationArray(): FormArray {
		return this.group.get('educationAndWorkDetails').get('educationalDetails') as FormArray;
	}
	// getPersonalDetails() {
	// 	this.shareDataSerice.getData().subscribe(res => {
	// 		this.personDetails = res;
	// 		console.log(this.personDetails, 'getpersonla');
	// 	});
	// }

	getEducationOptions() {
		this.dropdownService.getEducationalQualifications().subscribe((educations) => {
			this.educationOptions = educations;
		}, error => {
			console.log(`There was error fetching educations options :${error}`);
		});
	}

	setMonthsOptions() {
		for (let i = 0; i < 12; i++) {
			this.monthsOptions.push(i);
		}
	}

	get educationalDetails(): FormArray {
		return this.group.get('educationAndWorkDetails').get('educationalDetails') as FormArray;
	}

	setYearsOptions() {
		const years = [];
		const currentDate = new Date();
		const yearOFEst = Number(currentDate.getFullYear());
		for (let i = yearOFEst; i > yearOFEst - 20; i--) {
			this.yearsOptions.push(i);
		}
		return this.yearsOptions;
	}

	createEducationForm(value?: any) {
		console.log(value,"value")
		this.localFileName = {};
		console.log(this.educationalDetails);
		this.educationalDetails.push(this.fb.group({
			education: [value ? value.education : '', [Validators.required]],
			specialization: [value ? value.specialization : '', [Validators.pattern('^[a-zA-Z][a-zA-Z0-9 .\'-]+$')]],
			passingYear: [value ? value.passingYear : null, [Validators.maxLength(4), Validators.pattern('[1-9][0-9]{3}')]],
			document: [value ? value.document : null, [Validators.required, ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'), ValidationService.fileSizeValidator(5)]]
		}));
		console.log(this.educationalDetails);
	}

	addEducationDetails(i) {
		if (this.educationalDetails.valid) {
			this.createEducationForm();
		} else {
			console.log('Error in Education form');
		}
	}

	deleteEducationDetail(index) {
		this.educationalDetails.removeAt(index);
	}

	setEducation(educationObj, index) {
		console.log(educationObj)
		console.log(index);
		console.log(educationObj.get('education'));
		console.log('Entered');
		if (educationObj.get('education').value === 'Uneducated') {
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('specialization').setValidators([]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('passingYear').setValidators([]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('document').setValidators([]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('specialization').updateValueAndValidity();
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('passingYear').updateValueAndValidity();
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('document').updateValueAndValidity();
			educationObj.get('specialization').setValue('');
			educationObj.get('passingYear').setValue(null);
			educationObj.get('document').setValue(null);
		} else {
			console.log('Entered else');
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('specialization').setValidators([Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9-/,. \.\s]*$/)]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('passingYear').setValidators([Validators.required, Validators.maxLength(4), Validators.pattern('[1-9][0-9]{3}')]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('document').setValidators([Validators.required, ValidationService.fileValidator, ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'), ValidationService.fileSizeValidator(5)]);
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('specialization').updateValueAndValidity();
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('passingYear').updateValueAndValidity();
			this.group.get('educationAndWorkDetails').get('educationalDetails')['controls'][index].get('document').updateValueAndValidity();
			educationObj.get('specialization').setValidators([Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z0-9 .\'-]+$')]);

			educationObj.get('passingYear').setValidators([Validators.required, Validators.maxLength(4), Validators.pattern('[1-9][0-9]{3}')]);

			educationObj.get('document').setValidators([Validators.required, ValidationService.fileValidator, ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'), ValidationService.fileSizeValidator(5)]);
		}
	}

}
